export default __webpack_public_path__ + "static/media/484.2a27621d.gif";